export default __webpack_public_path__ + "static/media/biz-dash-materials.6aab05e6.png";